import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/right_arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/industries.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/managers.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/stakeholders.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/consumer_research.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/consumerResearch/consumerinsights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/marketAssessment/sales_and_marketing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
;
import(/* webpackMode: "eager" */ "/app/public/solution/img.png");
